"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Block_1 = require("modules/Block");
var Initializer_1 = require("modules/Initializer");
var dom_1 = require("modules/dom");
var BundlingBlockFilterTemplate_hbs_1 = __importDefault(require("./BundlingBlockFilterTemplate.hbs"));
var BundlingBlockTemplate_hbs_1 = __importDefault(require("./BundlingBlockTemplate.hbs"));
require("./bundling-block.scss");
var BundlingBlock = (function (_super) {
    __extends(BundlingBlock, _super);
    function BundlingBlock() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.handleBundleFilterLabelClick = function (e) {
            var label = e.currentTarget;
            if (!label || !(label instanceof HTMLElement))
                return;
            var input = label.previousElementSibling;
            if (!input || !(input instanceof HTMLInputElement))
                return;
            if (!input.checked) {
                if (input.value === "monthly") {
                    _this.rootElement.classList.add("monthly");
                    _this.rootElement.classList.remove("yearly");
                }
                else {
                    _this.rootElement.classList.remove("monthly");
                    _this.rootElement.classList.add("yearly");
                }
            }
        };
        return _this;
    }
    BundlingBlock.prototype.init = function () {
        this.triggerPricingModal();
        this.toggleBundleFilter();
        this.equalHeight();
    };
    BundlingBlock.prototype.toggleBundleFilter = function () {
        var _this = this;
        var filter = this.rootElement.querySelector(".js-bundle-filter");
        var labels = filter === null || filter === void 0 ? void 0 : filter.querySelectorAll("label");
        if (!labels)
            return;
        labels.forEach(function (label, labelIndex) {
            var input = label.previousElementSibling;
            var id = "bundle-filter-".concat(_this.index, "-").concat(labelIndex);
            if (!input || !(input instanceof HTMLInputElement))
                return;
            label.htmlFor = id;
            input.id = id;
            label.addEventListener("click", _this.handleBundleFilterLabelClick);
        });
    };
    BundlingBlock.prototype.triggerPricingModal = function () {
        var _this = this;
        var buttons = this.rootElement.querySelectorAll(".js-pricing-modal-trigger");
        buttons.forEach(function (button) {
            button.addEventListener("click", function (e) {
                var _a, _b;
                var button = e.currentTarget;
                if (!button || !(button instanceof HTMLButtonElement))
                    return;
                var id = button.dataset.id;
                var modal = _this.rootElement.querySelector("[data-formid='" + id + "']");
                if (modal === null) {
                    modal = _this.rootElement.querySelector(".js-pricing-modal-block");
                }
                if (!modal)
                    return;
                var selectedItem = ((_b = (_a = button.closest(".js-bundle-data")) === null || _a === void 0 ? void 0 : _a.querySelector(".bundle-title")) === null || _b === void 0 ? void 0 : _b.innerText) || "";
                modal.style.display = "flex";
                _this.renderPricingModalContent(selectedItem);
                modal.addEventListener("click", function (e) {
                    var modal = e.currentTarget;
                    var target = e.target;
                    if (!target || !(target instanceof HTMLElement) || !modal || !(modal instanceof HTMLDivElement)) {
                        return;
                    }
                    if (target.classList.contains("modal-form__close") || target.classList.contains("js-pricing-modal-block")) {
                        modal.style.display = "none";
                    }
                });
            });
        });
    };
    BundlingBlock.prototype.renderPricingModalContent = function (selectedItem) {
        var packages = this.rootElement.querySelectorAll(".js-bundle-data");
        var dataTargetContent = this.rootElement.querySelector(".js-pricing-modal-content");
        var dataTargetFilters = this.rootElement.querySelector(".js-pricing-filters");
        var data = [];
        packages.forEach(function (p) {
            var _a, _b, _c, _d, _e;
            var packageTitle = (_a = p.querySelector(".bundle-title")) === null || _a === void 0 ? void 0 : _a.innerText;
            var isSelected = selectedItem === packageTitle;
            var obj = {
                "title": packageTitle,
                "text": (_b = p.querySelector(".bundle-description")) === null || _b === void 0 ? void 0 : _b.innerText,
                "price": (_c = p.querySelector(".js-price-month")) === null || _c === void 0 ? void 0 : _c.innerText,
                "priceLabel": (_d = p.querySelector(".js-price-month.price-label")) === null || _d === void 0 ? void 0 : _d.innerText,
                "isHighlight": (_e = p.closest(".card")) === null || _e === void 0 ? void 0 : _e.classList.contains("is-highlight"),
                "selected": isSelected
            };
            data.push(obj);
        });
        if (dataTargetContent !== null && dataTargetFilters !== null) {
            dataTargetContent.innerHTML = (0, BundlingBlockTemplate_hbs_1.default)(data);
            dataTargetFilters.innerHTML = (0, BundlingBlockFilterTemplate_hbs_1.default)(data);
        }
        this.updateHiddenInput(selectedItem);
        this.togglePackagePricingFilters();
    };
    BundlingBlock.prototype.updateHiddenInput = function (selectedTitle) {
        var formBlock = this.rootElement.querySelector(".form-block");
        var hiddenInput = formBlock === null || formBlock === void 0 ? void 0 : formBlock.querySelector('input.PricingInformation');
        if (hiddenInput != null) {
            hiddenInput.value = "";
            hiddenInput.value = selectedTitle;
        }
    };
    BundlingBlock.prototype.togglePackagePricingFilters = function () {
        var _this = this;
        var packagePricingFilters = this.rootElement.querySelector(".js-pricing-filters");
        var labels = packagePricingFilters === null || packagePricingFilters === void 0 ? void 0 : packagePricingFilters.querySelectorAll(".pricing-filter-label");
        labels === null || labels === void 0 ? void 0 : labels.forEach(function (label) {
            label.addEventListener("click", _this.handlePricingFilterLabelClick);
        });
    };
    BundlingBlock.prototype.handlePricingFilterLabelClick = function (e) {
        var label = e.currentTarget;
        if (!label || !(label instanceof HTMLLabelElement))
            return;
        var id = label.htmlFor;
        var parent = label.closest(".js-pricing-modal-block");
        var formBlock = parent === null || parent === void 0 ? void 0 : parent.querySelector(".form-block");
        var hiddenInput = formBlock === null || formBlock === void 0 ? void 0 : formBlock.querySelector('input.PricingInformation');
        if (hiddenInput != null) {
            hiddenInput.value = "";
            hiddenInput.value = label.innerText;
        }
        var prices = parent === null || parent === void 0 ? void 0 : parent.querySelectorAll(".price-info");
        var target = parent === null || parent === void 0 ? void 0 : parent.querySelector(".price-info[data-id='".concat(id, "']"));
        prices === null || prices === void 0 ? void 0 : prices.forEach(function (price) {
            price.classList.add("hidden");
        });
        target === null || target === void 0 ? void 0 : target.classList.remove("hidden");
    };
    BundlingBlock.prototype.equalHeight = function () {
        (0, dom_1.equalizeHeight)('.bundle-top', this.rootElement);
        (0, dom_1.equalizeHeight)('.bundle-data', this.rootElement);
    };
    return BundlingBlock;
}(Block_1.Block));
Initializer_1.Initializer.initBlock(".js-bundling-block", BundlingBlock);
